var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('section',[_c('header',[_c('h2',[_vm._v("Account management for "+_vm._s(_vm.$store.state.firstname)+" "+_vm._s(_vm.$store.state.lastname))])]),_c('LogoutForm'),_c('router-link',{attrs:{"to":"/accountsettings"}},[_c('h3',[_vm._v(" Account Settings ")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }